module.exports = __webpack_public_path__ + "static/media/services-1.73d2b5dd.svg";